/*
  Login form component - migrated from jwt-bch-frontend
*/

import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Form, Alert, Spinner } from 'react-bootstrap'
import { handleLogin, setUser } from '../../services/auth'
import NOTIFICATION from '../../lib/notification'

const SERVER = process.env.REACT_APP_AUTHSERVER || process.env.AUTHSERVER
const Notification = new NOTIFICATION()

function LoginForm () {
  const navigate = useNavigate()
  const [inFetch, setInFetch] = useState(false)
  const [message, setMessage] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLoginClick(e)
    }
  }

  const validateEmail = (email) => {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true
    }
    return false
  }

  const handleCreateClick = async (event) => {
    try {
      event.preventDefault()

      if (!email) {
        setMessage('Error: Must be Email Format')
        Notification.notify('Email', 'Must be Email Format', 'danger')
        return
      }

      setInFetch(true)

      try {
        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user: {
              email,
              password
            }
          })
        }

        const data = await fetch(`${SERVER}/users/`, options)
        const users = await data.json()
        console.log(`users: ${JSON.stringify(users, null, 2)}`)

        setUser({
          email: users.user.email,
          username: users.user.username,
          jwt: users.token,
          userdata: users
        })

        Notification.notify('LogIn', 'Success!!', 'success')
        setInFetch(false)
        setTimeout(() => {
          navigate('/profile')
        }, 1500)
      } catch (err) {
        setMessage(err.message)
        Notification.notify('Error', err.message, 'danger')
        setInFetch(false)
      }
    } catch (err) {
      Notification.notify('Error', err.message, 'danger')
      setInFetch(false)
    }
  }

  const handleLoginClick = async (event) => {
    try {
      event.preventDefault()
      const isEmail = validateEmail(email)

      if (!isEmail) {
        setMessage('Error: Must be Email Format')
        Notification.notify('Email', 'Must be Email Format', 'danger')
        return
      }

      const handleSuccess = await handleLogin({ email, password })

      if (!handleSuccess) {
        setMessage('Username or password does not match.')
        Notification.notify(
          'Error',
          'Email or password does not match.',
          'danger'
        )
      } else {
        Notification.notify('LogIn', 'Success!!', 'success')
        setTimeout(() => {
          navigate('/profile')
        }, 1500)
      }
    } catch (err) {
      Notification.notify('Error', err.message, 'danger')
    }
  }

  return (
    <Form>
      <Form.Group className='mb-3'>
        <Form.Label>Email:</Form.Label>
        <Form.Control
          type='email'
          name='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder='Enter email'
        />
      </Form.Group>

      <Form.Group className='mb-3'>
        <Form.Label>Password:</Form.Label>
        <Form.Control
          type='password'
          name='password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder='Enter password'
        />
      </Form.Group>

      {!inFetch && (
        <div className='d-flex gap-2 justify-content-center mb-3'>
          <Button
            variant='primary'
            onClick={handleCreateClick}
            id='createBtn'
          >
            Create
          </Button>
          <Button
            variant='primary'
            onClick={handleLoginClick}
            id='loginBtn'
          >
            Login
          </Button>
        </div>
      )}

      {inFetch && (
        <div className='text-center mb-3'>
          <Spinner animation='border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
        </div>
      )}

      {message && (
        <Alert variant='danger'>{message}</Alert>
      )}
    </Form>
  )
}

export default LoginForm
